import { RAW_MATERIAL_ISSUE_CHALLAN_REQUEST, CREATE_RAW_MATERIAL_ISSUE_CHALLAN, GET_RAW_MATERIAL_ISSUE_CHALLANS, UPDATE_RAW_MATERIAL_ISSUE_CHALLAN, 
  DELETE_RAW_MATERIAL_ISSUE_CHALLAN, RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE } from '../types';

const initialState = {
  rawMaterialIssueChallans: [],
  loading: false,
  error: null,
};

const rawMaterialIssueChallanReducer = (state = initialState, action) => {
  switch (action.type) {
    case RAW_MATERIAL_ISSUE_CHALLAN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_RAW_MATERIAL_ISSUE_CHALLANS: {
      return {
        ...state,
        rawMaterialIssueChallans: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_RAW_MATERIAL_ISSUE_CHALLAN:
      return {
        ...state,
        rawMaterialIssueChallans: [action.payload, ...state.rawMaterialIssueChallans],
        loading: false,
        error: null
      };
    case UPDATE_RAW_MATERIAL_ISSUE_CHALLAN:
      const rawMaterialIssueChallansData = state.rawMaterialIssueChallans.slice(0);
      const uIndex = rawMaterialIssueChallansData.findIndex((data) => data.id === action.payload.id);
      rawMaterialIssueChallansData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        rawMaterialIssueChallans: [ ...rawMaterialIssueChallansData ],
        loading: false,
        error: null
      };
    case DELETE_RAW_MATERIAL_ISSUE_CHALLAN:
      const rawMaterialIssueChallans = state.rawMaterialIssueChallans?.slice(0);
      const index = rawMaterialIssueChallans.findIndex((data) => data.id === action.id);
      if (index > -1) {
        rawMaterialIssueChallans.splice(index, 1);
      }
      return {
        ...state,
        rawMaterialIssueChallans: [...rawMaterialIssueChallans],
        loading: false,
        error: null
      }
    case RAW_MATERIAL_ISSUE_CHALLAN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default rawMaterialIssueChallanReducer;
